module.exports = __webpack_public_path__ + "static/media/0019.558d9d9f.jpg";